import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { usePanelContext } from '../../contexts/PanelProvider';
import useClosingPanel from '../../lib/hooks/useClosingPanel';

import Button from '../Button';

import './panel.scss';

const Panel = () => {
    const { panelOpened, panelProps, closingAnimatedPanel, isFullScreen, setIsFullScreen } = usePanelContext();
    const sidebarNarrow = useSelector((state) => state.view.sidebarNarrow);

    const { onClosingPanel } = useClosingPanel();

    useEffect(() => {
        if (panelOpened) {
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = 'scroll';
            };
        }
    }, [panelOpened]);

    useEffect(() => {
        window.onpopstate = () => {
            onClosingPanel(); // to handle back button
        };
    }, [onClosingPanel]);

    useEffect(() => {
        function handleEscapeKey(event) {
            if (event.code === 'Escape' || event.code === 'backbutton') {
                onClosingPanel();
            }
        }
        document.addEventListener('keydown', handleEscapeKey);
        return () => document.removeEventListener('keydown', handleEscapeKey);
    }, [panelProps, onClosingPanel]);

    const panelContainerClass = classNames('Panel-container', {
        'closing-panel': closingAnimatedPanel,
        'opening-panel': !closingAnimatedPanel,
    });

    return (
        <>
            {panelOpened && (
                <>
                    <div className="Panel-blur-container" onClick={onClosingPanel} />
                    <div
                        className={panelContainerClass}
                        style={
                            isFullScreen
                                ? { width: 'auto', left: sidebarNarrow ? '4rem' : '16rem', right: 0 }
                                : { width: panelProps.panelWidth }
                        }
                    >
                        <div className="Panel-content">
                            <div
                                className="Panel-content-header"
                                style={{ width: isFullScreen ? '100%' : panelProps.panelWidth }}
                            >
                                <div className="Panel-content-header-text">
                                    <div className="f ai-c">
                                        <Button
                                            icon="CaretDoubleRight"
                                            color="secondary"
                                            onClick={onClosingPanel}
                                            iconWeight="regular"
                                        />
                                        <div className="ml-24">{panelProps.title}</div>
                                    </div>
                                    <Button
                                        icon={isFullScreen ? 'ArrowsIn' : 'ArrowsOut'}
                                        color="secondary"
                                        onClick={() => setIsFullScreen(!isFullScreen)}
                                    />
                                </div>
                            </div>
                            <div className="Panel-content-element">{panelProps.contentElement}</div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Panel;
